import { Brand } from '@jucy-ui/common';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
export const DEFAULT_BRAND: Brand = (typeof document !== 'undefined' && (document.documentElement.dataset.brand as Brand)) || 'jucy';
export const DEFAULT_LOCALE: string = (typeof window !== 'undefined' && window.navigator.language.substring(0, 2)) || 'en';
